import SelectedChannelsTable from './SelectedChannelsTable'

export default SelectedChannelsTable
